import { getThumbnailsUrlsFromList, replaceHtml, toTimeStamp as _toTimeStamp } from '../../../utils/utils';
import { MediaType } from '../../../constants/MediaType';
export function toItem(settings, data) {
  function getAttribute(htmlElement, attributeName) {
    const regex = new RegExp(attributeName + "=\"(.+?)\"", 'i');
    const res = htmlElement.match(regex);
    return res ? res[1] : '';
  }
  function toTimeStamp(date) {
    const correctDate = date.replace(/([+-]\d\d)(\d\d)$/, '$1:$2');
    return _toTimeStamp(correctDate);
  }
  const item = {
    id: Number(data.id),
    name: replaceHtml(data.title),
    iframeSrc: getAttribute(data.embed_html, 'src'),
    embedHtml: data.embed_html,
    width: Number(getAttribute(data.embed_html, 'width')),
    height: Number(getAttribute(data.embed_html, 'height')),
    createdAt: toTimeStamp(data.created_time),
    folderId: null,
    mediaType: MediaType.Video
  };
  if (!data.format) {
    return item;
  }
  const availableThumbnailsSizes = data.format.map(function (pictureSize) {
    return {
      ...pictureSize,
      url: pictureSize.picture
    };
  });
  const urls = getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
  return {
    ...item,
    ...urls
  };
}